/**
 * POC animated lobby — Motion Tier Manager.
 *
 * Decides the motion tier once at boot (`?motion=` override, prefers-reduced-motion, true mobile +
 * cores + physical pixels), stamps `html[data-fx="1"]` and `html[data-motion-tier]`, and registers
 * the effects bus with the idle manager so everything in flight is dropped and new plays are
 * ignored while the lobby is idle behind a game, exactly as the seasonal effects in App.tsx.
 * Only ever called when FX_ENABLED is true (App.tsx), so with the flag off nothing is written.
 */

import { applyMotionTier, clearMotionTier, effectsBus, FX_ATTRIBUTE, resolveMotionTier } from 'shared/effects';
import type { MotionTier } from 'shared/effects';
import { isTrueMobile } from 'shared/utils/isTrueMobile';
import { idleManager } from './IdleManager';

const IDLE_PROCESS_ID = 'fx-effects';

export const initMotionTier = (): MotionTier => {
  const tier = resolveMotionTier({ trueMobile: isTrueMobile() });
  document.documentElement.setAttribute(FX_ATTRIBUTE, '1');
  applyMotionTier(tier);
  idleManager.registerProcess(
    IDLE_PROCESS_ID,
    () => effectsBus.resume(),
    () => effectsBus.suspend(),
  );
  return tier;
};

export const disposeMotionTier = (): void => {
  idleManager.unregisterProcess(IDLE_PROCESS_ID);
  effectsBus.cancel();
  clearMotionTier();
};
